module.exports = __webpack_public_path__ + "img/comp-sipeed.fc13aa21.svg";